import { UserViewModel } from './../../models/comparison/comparison-answers';
import { ZohoAction } from './../../models/enums';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { QuestionView } from '../../models/comparison/question-view';
import { environment } from '../../../../environments/environment';
import {
  ComparisonViewModel,
  PurchaseViewModel,
} from '../../models/comparison/comparison-view.model';
import { BenefitViewModel } from '../../models/optional-benefits/benefit-view.model';
import { ComparisonAnswers, CongratulationViewModel, UserCreateResult } from '../../models/comparison/comparison-answers';

@Injectable()
export class ComparisonService {
  constructor(private http: HttpClient) {
  }

  public getClientQuestions(specification: number): Observable<QuestionView[]> {
    return this.http.get<QuestionView[]>(`${environment.apiUrl}/api/comparison/question/filter/${specification}`)
      .pipe(map((response: any[]) => response.map(x => new QuestionView(x))));
  }

  public getCalculationVerify(answers: ComparisonAnswers): Observable<ComparisonViewModel> {
    return this.http.post(`${environment.apiUrl}/api/comparison/insurances`,
      answers).pipe(map((response: any[]) => new ComparisonViewModel(response)));
  }

  public postAnswerToZoho(answers: ComparisonAnswers, zohoAction: ZohoAction, gclid: string): Observable<any> {
    const id =  + gclid ? `?gclid=${gclid}` : '';
    return this.http.post(`${environment.apiUrl}/api/comparison/zoho/${zohoAction}${id}`, answers)
      .pipe(map((response: any) => response));
  }


  public getCalculationVerifyFinal(answers: ComparisonAnswers): Observable<BenefitViewModel> {
    return this.http.post(`${environment.apiUrl}/api/comparison/insurance/additions`,
      answers).pipe(map((response: any[]) => new BenefitViewModel(response)));
  }

  public getInsurancePurchase(answers: ComparisonAnswers): Observable<PurchaseViewModel> {
    return this.http.post(`${environment.apiUrl}/api/comparison/insurance/purchase`,
      answers).pipe(map((response: any[]) => new PurchaseViewModel(response)));
  }

  public getInsuranceCongratulation(answers: ComparisonAnswers): Observable<CongratulationViewModel> {
    return this.http.post(`${environment.apiUrl}/api/comparison/insurance/congratulation`,
      answers).pipe(map((response: any[]) => new CongratulationViewModel(response)));
  }

  public getInsuranceCongratulationPayment(answers: ComparisonAnswers, paymentType: number): Observable<UserCreateResult> {
    return this.http.post(`${environment.apiUrl}/api/comparison/insurance/payment/${paymentType}`,
      answers).pipe(map((response: any[]) => new UserCreateResult(response)));
  }

  public getAnswers(guid: string): Observable<ComparisonAnswers> {
    return this.http.get(`${environment.auth.identityUrl}/api/answer/${guid}`)
      .pipe(map((response: any[]) => new ComparisonAnswers(response)));
  }

  public getPersonalInfo(userId: string): Observable<UserViewModel> {
    return this.http.get(`${environment.auth.identityUrl}/api/user/${userId}`)
      .pipe(map((response: any[]) => new UserViewModel(response)));
  }
}
